<template>
    <div class="dna-container">
        <div id="dna-animation" v-in-viewport="log_one" ></div>
    </div>
</template>

<script>
import lottie from 'lottie-web'
import dnaAnimationJson from '@/assets/DNA-Strand.json'
  import InViewport from 'v-in-viewport';
export default {
    directives: {
        InViewport
    },
    data(){
        return {
            params: {},
            anim: '',
            animData: dnaAnimationJson,
            hasLooped: false,
            processLoopFrame: 60,
            activateHovers: false,
            hasPlayed: false,
            lottiloaded: false,
            reachedlog: false
        }
    },
    methods: {
            log_one () {
               let vm = this;
               vm.reachedlog = true;
              if(!vm.hasPlayed && vm.lottiloaded){
                  vm.anim.play();
                     vm.hasPlayed = true;
              }
        },
    },
    mounted(){
        let vm = this;
        vm.params = {
            container: document.querySelector('#dna-animation'),
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: vm.animData
        };
        
        vm.anim = lottie.loadAnimation(vm.params);
        vm.lottiloaded = true;
        window.onresize = vm.anim.resize.bind(vm.anim);


        // vm.anim.addEventListener("enterFrame", function (animation) {
        //     if (animation.currentTime > (vm.anim.totalFrames - 2900)) {
        //         vm.anim.pause();
        //  }
        // });
    },
        watch: { 
          lottiloaded: function(){
                let vm = this;
              if(!vm.hasPlayed && vm.lottiloaded && vm.reachedlog){
                  vm.anim.play();
                  vm.hasPlayed = true;
              }
          }
    }
}
</script>

<style>


/* #dna-animation {
    transform: scale(1.5);
} */
    .dna-container{
        /* position: relative;
        width: 100%;
        max-width: 1000px;
            min-height: 50vw;
        height: 500px;
        margin: 0 auto; */
    }
    .dna-container > #dna-animation{
        /* position: absolute;
        top: -150px;
        left: 0;
        right: 0;
        bottom: 0; */

    /* position: absolute;
    top: 0;
    left: -13%;
    right: 0;

    width: 130vw; */
        
    }

    .dna-container > svg{
        /* width: 100%;
        height: 100%;
        transform: translate3d(0px, 0px, 0px); */
    }
</style>
